import { Directive, ElementRef } from '@angular/core';


@Directive({
  selector: '[autofocus]',
  standalone: false
})
export class AutofocusDirective {

	constructor(private host: ElementRef) {}

  ngAfterViewInit() {
	let ua = navigator.userAgent;
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) return;
    this.host.nativeElement.focus({preventScroll: true});
  }

}
